import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import { useTranslation } from "react-i18next";

// 原本的 CRS 图例颜色配置
const crsColors = {
  fontColor: ["#000000", "#275317", "#4ea72e", "#9c0006", "#9c0006", "#ffffff"],
  backgroundColor: [
    "#F2F2F2",
    "#b5e6a2",
    "#daf2d0",
    "#ffffcc",
    "#ffc7ce",
    "#cc0000"
  ]
};

// futureHazard 的图例颜色配置（6 个等级）
const futureHazardColors = {
  fontColor: [
    "#000000",
    "#275317",
    "#4ea72e",
    "#9c0006",
    "#9c0006",
    "#9c0006",
    "#ffffff"
  ],
  backgroundColor: [
    "#F2F2F2",
    "#b5e6a2",
    "#daf2d0",
    "#ffffcc",
    "#F2AA84",
    "#ffc7ce",
    "#cc0000"
  ]
};

interface CrsLegendProps {
  category?: string;
}

export default function CrsLegend({ category = "crs" }: CrsLegendProps) {
  const [t] = useTranslation();

  const isFutureHazard = category === "futureHazard";

  // For futureHazard, use the new score labels for web page; for others use the original legend
  const legendKey = isFutureHazard
    ? "legend.futureHazardScoreLabels"
    : "legend.data";
  const colorConfig = isFutureHazard ? futureHazardColors : crsColors;

  let rows: any[] = [];

  if (isFutureHazard) {
    // For futureHazard, build rows from futureHazardData[0] (risk levels) + futureHazardScoreLabels (scores)
    const futureHazardData = (t("legend.futureHazardData", {
      returnObjects: true
    }) as any) || [[], []];
    const riskLevels = futureHazardData[0] || [];
    const scoreLabels = (t(legendKey, { returnObjects: true }) as any) || [];
    rows = [riskLevels, scoreLabels];
  } else {
    rows = t(legendKey, { returnObjects: true }) || [];
  }

  return (
    <TableContainer
      component={Paper}
      sx={{ width: 780, overflow: "auto", boxShadow: "none" }}
    >
      <Table
        sx={{
          border: "1px solid #d3d3d3",
          backgroundColor: "#F2F2F2",
          tableLayout: "fixed",
          width: "100%"
        }}
        size="small"
        aria-label="simple table"
      >
        <TableBody>
          {rows.map((row: any, i: number) => (
            <TableRow key={i}>
              {row.map((cell: string, j: number) => (
                <TableCell
                  key={j}
                  align={`${j === 0 ? "left" : "center"}`}
                  sx={{
                    border: "1px solid #d3d3d3",
                    fontSize: "14px",
                    whiteSpace: "nowrap",
                    width: `${100 / row.length}%`,
                    backgroundColor: colorConfig.backgroundColor[j],
                    color: colorConfig.fontColor[j]
                  }}
                >
                  {cell}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
